import React, { useCallback } from "react";

import {
	faCheckCircle,
	faChevronLeft,
	faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useEmblaCarousel from "embla-carousel-react";
import { ImageCard } from "./common/imageCard";
import { Button } from "./common/button";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { motion } from "framer-motion";

import { slides } from "../data/projectSlides";

interface Props { }

export const BrandSlider = (props: Props) => {
	const carouselOptions = {
		slidesToScroll: 1,
	};
	const [emblaRef, emblaApi] = useEmblaCarousel(carouselOptions);

	const scrollPrev = useCallback(() => {
		if (emblaApi) emblaApi.scrollPrev();
	}, [emblaApi]);

	const scrollNext = useCallback(() => {
		if (emblaApi) emblaApi.scrollNext();
	}, [emblaApi]);

	const Description = styled("div")`
		padding: 0 50px;
		h2 {
			font-size: 3rem;
			margin: 0;
			padding: 0;
		}
		p {
			font-size: 1.2rem;
			font-weight: 300;
			letter-spacing: 1.1px;
			line-height: 1.5;
		}
		ul {
			margin: 0;
			margin-top: 25px;
			padding: 0;
			li {
				list-style: none;
				margin: 10px 0;
				display: flex;
				align-items: center;
				span {
					font-family: Panton, Roboto, Helvetica, sans-serif;
					font-size: 1.5rem;
					font-weight: 700;
					margin-left: 8px;
				}
			}
		}
	`;

	const SliderControls = styled("div")`
		margin-top: 50px;
		display: flex;
		justify-content: flex-end;
		width: 100%;
		cursor: pointer;
		> :last-child {
			margin-left: 25px;
		}
	`;

	return (
		<section
			className="brand-slider-container"
			css={css`
				margin-bottom: 100px;
			`}
		>
			<Description>
				<motion.div
					initial={{ opacity: 0, y: -50 }}
					animate={{
						opacity: 1,
						y: 0,
					}}
					transition={{
						duration: 0.8,
						delay: 0.4,
						type: "spring",
						bounce: 0,
					}}
				>
					<h2>Our Brands</h2>
					<p>
						Moonsworth operates some of the most reputable brands in
						Minecraft, and we are always looking to expand into new
						and exciting industries. Always be on the lookout for
						new products!
					</p>
					<ul>
						<li>
							<Tick />
							<span>Development</span>
						</li>
						<li>
							<Tick />
							<span>Design</span>
						</li>
						<li>
							<Tick />
							<span>Management</span>
						</li>
					</ul>
				</motion.div>
				<SliderControls>
					<FontAwesomeIcon
						icon={faChevronLeft}
						color={"#535353"}
						size="2x"
						onClick={scrollPrev}
					/>
					<FontAwesomeIcon
						icon={faChevronRight}
						color={"#535353"}
						size="2x"
						onClick={scrollNext}
					/>
				</SliderControls>
			</Description>

			<div
				className="embla"
				ref={emblaRef}
				css={css`
					max-width: 100%;
					overflow-x: auto;

					&::-webkit-scrollbar {
						display: none;
					}
				`}
			>
				<div className="embla__container">
					{slides.map((slide, index) => (
						<motion.div
							initial={{ opacity: 0, y: -50 }}
							animate={{
								opacity: 1,
								y: 0,
							}}
							transition={{
								duration: 0.8,
								delay: 0.2 * index + 0.5,
								type: "spring",
								bounce: 0,
							}}
							key={slide.title}
							className="embla__slide"
						>
							<ImageCard
								bgImage={slide.bgImage}
								icon={slide.icon}
								title={slide.title}
								description={slide.description}
								extra={
									<Button
										type={slide.link ? "" : "submit"}
										href={slide.link}
									>
										{slide.link_text}
									</Button>
								}
							/>
						</motion.div>
					))}
				</div>
			</div>
		</section>
	);
};

const Tick = () => {
	return <FontAwesomeIcon icon={faCheckCircle} color="#64ba61" size="lg" />;
};
